import { render, staticRenderFns } from "./requestsApproval.vue?vue&type=template&id=cfc590a0&"
import script from "./requestsApproval.vue?vue&type=script&lang=js&"
export * from "./requestsApproval.vue?vue&type=script&lang=js&"
import style0 from "./requestsApproval.vue?vue&type=style&index=0&id=cfc590a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports